import { useApolloClient } from '@apollo/client';
import React from 'react';
import { ApolloSiteLayoutClient } from './apolloSiteLayoutClient';
import type { SiteLayoutClient } from './siteLayoutClient';

const SiteLayoutClientContext = React.createContext<SiteLayoutClient | null>(
  null,
);

/**
 * Supplies the `SiteLayoutClient` the layout designer reads and writes
 * through. Wrap a subtree to swap the implementation (tests); without a
 * provider the designer talks to the `siteLayout` GraphQL surface through
 * the app's Apollo client.
 */
export function SiteLayoutClientProvider({
  client,
  children,
}: React.PropsWithChildren<{ client: SiteLayoutClient }>): React.ReactElement {
  return (
    <SiteLayoutClientContext.Provider value={client}>
      {children}
    </SiteLayoutClientContext.Provider>
  );
}

export const useSiteLayoutClient = (): SiteLayoutClient => {
  const provided = React.useContext(SiteLayoutClientContext);
  const apollo = useApolloClient();
  return React.useMemo(
    () => provided ?? new ApolloSiteLayoutClient(apollo),
    [provided, apollo],
  );
};
